module.exports = __webpack_public_path__ + "img/safe-new.d9e8fddf.png";